import type { ActionDefinition } from '@gzl10/nexus-sdk'

/**
 * Row action — uninstalls an installed plugin via ctx.core.plugins.uninstall()
 */
export const uninstallPluginAction: ActionDefinition = {
  key: 'uninstall',
  scope: 'row',
  group: { en: 'Plugin Management', es: 'Gestión de plugins' },
  label: { en: 'Uninstall', es: 'Desinstalar' },
  icon: 'mdi:delete',
  output: {},

  confirm: {
    type: 'verify',
    message: { en: 'This will uninstall the plugin, remove its data, and restart the server.', es: 'Esto desinstalará el plugin, eliminará sus datos y reiniciará el servidor.' },
    verifyText: 'UNINSTALL',
    severity: 'error'
  },

  select: ['name'],

  handler: async (ctx, input) => {
    const { _record } = input as { _record: { name: string } }
    const name = _record.name

    ctx.core.logger.info({ name }, 'Uninstalling plugin')

    ctx.events.notify('audit.log', {
      source: 'core:plugins',
      action: 'plugin_uninstalled',
      resourceType: 'plugin',
      resourceId: name
    })

    try {
      await ctx.core.plugins.uninstall(name)
    } catch (error) {
      ctx.core.logger.error({ error, name }, 'Failed to uninstall plugin')
      throw new ctx.core.errors.AppError(`Failed to uninstall plugin: ${(error as Error).message}`, 500)
    }

    ctx.core.logger.info({ name }, 'Plugin uninstalled, scheduling restart')

    setTimeout(() => {
      process.exit(0)
    }, 500)

    return {
      success: true,
      message: `Plugin ${name} uninstalled. Server restarting...`
    }
  }
}
